import { render, staticRenderFns } from "./representativelist.vue?vue&type=template&id=31e81a8c&"
import script from "./representativelist.vue?vue&type=script&lang=js&"
export * from "./representativelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports